import { gql } from '@common/hooks';
import { DetailItemAttachments } from '@onboarding/graphql/fragments';

export const SSNQuery = gql`
  query WorksProfileSsn($id: ID!) {
    worksProfileSsn(id: $id)
  }
`;

export type SSNQueryResponse = {
  worksProfileSsn: string;
};

export type SSNQueryArgs = {
  id: string;
};

export const DateOfBirthQuery = gql`
  query WorksProfileDateOfBirth($id: ID!) {
    worksProfileDateOfBirth(id: $id) {
      id
      dateOfBirth
    }
  }
`;

export type DateOfBirthQueryResponse = {
  worksProfileDateOfBirth: {
    id: string;
    dateOfBirth: string | undefined;
  };
};

export type DateOfBirthQueryArgs = {
  id: string;
};

export const CanShowPhiQuery = gql`
  query CanShowPhiQuery($id: ID!) {
    worksProfile(id: $id) {
      id
      canShowPhi {
        value
      }
    }
  }
`;

export type CanShowPhiQueryQueryResponse = {
  worksProfile: {
    id: string;
    canShowPhi: {
      value: boolean;
    };
  };
};

export type CanShowPhiQueryQueryArgs = {
  id: string;
};

export const WorksProfileQuery = gql`
  query supplierWorksProfile($id: ID!) {
    worksProfile(id: $id) {
      id
      firstName
      lastName
      fullName
      phone
      email
      profileSummary
      profileType
      role {
        id
        name
      }
      primarySpecialty {
        id
        displayName
      }
      secondarySpecialties {
        id
        displayName
      }

      licenses {
        id
        friendlyLicenseType
        licenseType
        stateCode
        expiresOn
        compact
        number
        detailItemAttachments {
          ...DetailItemAttachments
        }
      }
    }
  }
  ${DetailItemAttachments}
`;
